import {InputLabel, TextField, useMediaQuery, Button, FormControl, FormLabel, MenuItem, Select} from "@material-ui/core";
import {DatePicker} from "@material-ui/pickers";
import {MaterialUiPickersDate} from "@material-ui/pickers/typings/date";
import {BulletinFilters} from "Agent/AgentForms/Bulletins/ducks/Bulletin";
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import * as Luxon from "luxon";
import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {BulletinTypes} from "./Bulletins";

type SearchFormProps = {
    setIsSearchBlock: (value: boolean | ((isSearchBlock: boolean) => boolean)) => void;
    formName: string;
    filters: BulletinFilters;
    filter: (filter: BulletinFilters) => void;
}

const BulletinSearchForm = ({setIsSearchBlock, formName, filters, filter}: SearchFormProps) => {
    const dispatch = useDispatch();
    const [markFilter, setMarkFilter] = useState(filters);
    const [originalFilter] = useState(filters);

    function handleChange(event: any) {
        if (event?.target?.name === 'bulletinType') {
            setMarkFilter({
                              ...markFilter,
                              [event.target.name]: {
                                  'name': event.target.value,
                                  'value': event.target.value,
                                  'tag': 'SelectedOption',
                              },
                          });
        } else {
            setMarkFilter({...markFilter, [event.target.name]: event.target.value});

        }

    }

    function setStartDate(date: MaterialUiPickersDate, field: string) {
               setMarkFilter({

                          ...markFilter,
                          [field]: {
                              'startDate': (date !== undefined && date != null) ? date!.toJSDate() : "",
                              'endDate': (markFilter.created.endDate !== undefined && markFilter.created.endDate !== null) ? markFilter.created.endDate : "",
                          },
                      });
    }

    function setEndDate(date: MaterialUiPickersDate, field: string) {
        setMarkFilter({
                          ...markFilter,
                          [field]: {
                              'endDate': (date !== undefined && date != null) ? date!.toJSDate() : "",
                              'startDate': (markFilter.created.startDate !== undefined && markFilter.created.startDate !== null) ? markFilter.created.startDate : "",
                          },
                      });

    }

    const handleClose = () => {
        if (originalFilter !== filters) {
            dispatch(filter({...originalFilter}))
        }
        setIsSearchBlock(false);
    }

    const handleSubmit = () => {
        setIsSearchBlock(false)
        if (markFilter !== filters) {
            dispatch(
                filter({...markFilter}));
        }
    }
    const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));

    const handleMobile = () => {
        return isDesktop ? "search-form-desktop-view" : "card-filter-overlay slideIn"
    }

    return (
        <div className={handleMobile()}>
            <div className="drawer-sections">
                <div className="dropdown-section">
                    <FormControl component="fieldset" className="drawer-title">
                        <div className="form-control-label">
                            <FormLabel id="marketing-forms-drawer-title" component="legend"
                                       className="form-drawer-label">{formName}</FormLabel>
                            <span className="close-button"
                                  onClick={handleClose}>
                            <i className="fa fa-times" aria-hidden="true" />
                        </span>
                        </div>
                    </FormControl>
                    <FormControl className="field-section-body">
                        <TextField style={{cursor: 'pointer'}} placeholder="Subject Line" label="Subject Line"
                                   name="bulletinSubject"

                                   onChange={e => handleChange(e)} value={markFilter.bulletinSubject}/>
                    </FormControl>
                    <FormControl className="field-section-body">
                        <DatePicker
                            clearable
                            id="dateFrom"
                            name="DateFromPicker"
                            style={{cursor: 'pointer'}}
                            label="Date From"
                            format="MM/dd/yyyy"
                            maxDate = {markFilter.created.endDate ? Luxon.DateTime.fromJSDate(markFilter.created.endDate) : undefined}
                            value={markFilter.created.startDate || null}
                            onChange={e => setStartDate(e, 'created')}
                        />
                    </FormControl>
                    <FormControl className="field-section-body">
                        <DatePicker
                            clearable
                            name="DateToPicker"
                            label="Date To"
                            style={{cursor: 'pointer'}}
                            format="MM/dd/yyyy"
                            minDate = {markFilter.created.startDate ? Luxon.DateTime.fromJSDate(markFilter.created.startDate) : undefined}
                            value={markFilter.created.endDate || null}
                            onChange={e => setEndDate(e, 'created')}
                        />
                    </FormControl>
                    <FormControl className="field-section-last">
                        <InputLabel variant="standard" htmlFor="uncontrolled-native">
                            Bulletin Type
                        </InputLabel>
                        <Select
                            onChange={e => handleChange(e)} name="bulletinType"
                            value={markFilter.bulletinType?.tag === 'SelectedOption' ? (markFilter.bulletinType?.value !== '' ? markFilter.bulletinType.value.toString() : '') : ''}
                            inputProps={{
                                name: 'bulletinType',
                                id: 'uncontrolled-native',
                            }}
                        >
                            {BulletinTypes.map((type) => (
                                <MenuItem key={type.name} value={type.value}>
                                    {type.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div className="button-section">

                <Button id="handleSubmitBtn" variant="contained" color="primary" className="btn-submit" onClick={handleSubmit}>
                    Submit
                </Button>
                <Button
                    id="handleCancelBtn"
                    className="btn-submit search-form-shadow"
                    variant="contained"
                    color="default"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
            </div>
        </div>
    );
}

export default BulletinSearchForm;

